import { request } from "./http";

export interface RiskLimit {
  id: string;
  user_id: string | null;
  strategy_id: string | null;
  limit_type: string;
  limit_value: string;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface RiskLimitCreate {
  limit_type: string;
  limit_value: string | number;
  user_id?: string | null;
  strategy_id?: string | null;
  enabled?: boolean;
}

export type RiskLimitPatch = {
  limit_value?: string | number;
  enabled?: boolean;
};

export const riskLimits = {
  list: () => request<RiskLimit[]>("/api/v1/risk-limits"),
  create: (body: RiskLimitCreate) => request<RiskLimit>("/api/v1/risk-limits", { body }),
  patch: (id: string, body: RiskLimitPatch) =>
    request<RiskLimit>(`/api/v1/risk-limits/${id}`, { method: "PATCH", body }),
  remove: (id: string) =>
    request<void>(`/api/v1/risk-limits/${id}`, { method: "DELETE" }),
};
